import { useId, useState, type ReactNode } from 'react'

/**
 * A label with a small help button next to it; the explanation opens BELOW
 * the label on click / Enter (frontend standard §6a: not a hover tooltip,
 * so it works on a phone and from the keyboard).
 */
export function HelpLabel({ label, help }: { label: ReactNode; help: string }) {
  const [open, setOpen] = useState(false)
  const id = useId()
  return (
    <>
      <span className="portal-help-label">
        {label}
        <button
          type="button"
          className="portal-help-btn"
          aria-expanded={open}
          aria-controls={id}
          aria-label={`What is ${typeof label === 'string' ? label : 'this'}?`}
          onClick={() => setOpen((v) => !v)}
        >
          ?
        </button>
      </span>
      {open && (
        <span id={id} className="portal-help-text" role="note">
          {help}
        </span>
      )}
    </>
  )
}
